// extracted by mini-css-extract-plugin
export default {"TableOrdersInfo":"Orders_TableOrdersInfo__hLmgb","outerItems":"Orders_outerItems__2FoOH","paper":"Orders_paper__VBBuh","ordersSearchbar":"Orders_ordersSearchbar__4RYnX"};